export const normalizeLinksInElement = (element: HTMLElement): void => {
  const links = element.querySelectorAll('a');

  links.forEach((link) => {
    const href = link.getAttribute('href');

    if (href && !href.match(/^(https?:\/\/|#|\/)/i)) {
      link.setAttribute('href', `https://${href}`);
    }
  });
};

export const normalizeLinksInHtml = (html: string): string => {
  if (!html) return html;

  const tempDiv = document.createElement('div');
  tempDiv.textContent = html;
  tempDiv.innerHTML = tempDiv.textContent || '';
  normalizeLinksInElement(tempDiv);

  return tempDiv.innerHTML;
};
